import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'block',
      component: () => import(/* webpackChunkName: "block0" */ './block0')
    },
    {
      path: '/block0/:id?',
      name: 'block0',
      props: true,
      component: () => import(/* webpackChunkName: "block0" */ './block0')
    },
    {
      path: '/block1/:id?',
      name: 'block1',
      props: true,
      component: () => import(/* webpackChunkName: "block1" */ './block1')
    },
    {
      path: '/block1a/:id?',
      name: 'block1a',
      props: true,
      component: () => import(/* webpackChunkName: "block1a" */ './block1a')
    },
    {
      path: '/block2/:id?',
      name: 'block2',
      props: true,
      component: () => import(/* webpackChunkName: "block2" */ './block2')
    },
    {
      path: '/block3/:id?',
      name: 'block3',
      props: true,
      component: () => import(/* webpackChunkName: "block3" */ './block3')
    },
    {
      path: '/block4/:id?',
      name: 'block4',
      props: true,
      component: () => import(/* webpackChunkName: "block4" */ './block4')
    },
    {
      path: '/block5/:id?',
      name: 'block5',
      props: true,
      component: () => import(/* webpackChunkName: "block5" */ './block5')
    },
    {
      path: '/block6/:id?',
      name: 'block6',
      props: true,
      component: () => import(/* webpackChunkName: "block6" */ './block6')
    },
    // {
    //   path: '/block7/:id?',
    //   name: 'block7',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block7" */ './block7')
    // },
    {
      path: '/block8/:id?',
      name: 'block8',
      props: true,
      component: () => import(/* webpackChunkName: "block8" */ './block8')
    },
    {
      path: '/block9/:id?',
      name: 'block9',
      props: true,
      component: () => import(/* webpackChunkName: "block9" */ './block9')
    },
    {
      path: '/block10/:id?',
      name: 'block10',
      props: true,
      component: () => import(/* webpackChunkName: "block10" */ './block10')
    },
    {
      path: '/block11/:id?',
      name: 'block11',
      props: true,
      component: () => import(/* webpackChunkName: "block11" */ './block11')
    },
    {
      path: '/block11a/:id?',
      name: 'block11a',
      props: true,
      component: () => import(/* webpackChunkName: "block11a" */ './block11a')
    },
    {
      path: '/block11b/:id?',
      name: 'block11b',
      props: true,
      component: () => import(/* webpackChunkName: "block11b" */ './block11b')
    },
    {
      path: '/block11c/:id?',
      name: 'block11c',
      props: true,
      component: () => import(/* webpackChunkName: "block11c" */ './block11c')
    },
    {
      path: '/block11d/:id?',
      name: 'block11d',
      props: true,
      component: () => import(/* webpackChunkName: "block11d" */ './block11d')
    },
    {
      path: '/block11e/:id?',
      name: 'block11e',
      props: true,
      component: () => import(/* webpackChunkName: "block11e" */ './block11e')
    },
    {
      path: '/block12/:id?',
      name: 'block12',
      props: true,
      component: () => import(/* webpackChunkName: "block12" */ './block12')
    },
    {
      path: '/block13/:id?',
      name: 'block13',
      props: true,
      component: () => import(/* webpackChunkName: "block13" */ './block13')
    },
    {
      path: '/block14/:id?',
      name: 'block11e',
      props: true,
      component: () => import(/* webpackChunkName: "block14" */ './block14')
    },
    {
      path: '/block14a/:id?',
      name: 'block14a',
      props: true,
      component: () => import(/* webpackChunkName: "block14a" */ './block14a')
    },
    {
      path: '/block14b/:id?',
      name: 'block14b',
      props: true,
      component: () => import(/* webpackChunkName: "block14b" */ './block14b')
    },
      {
        path: '/block14c/:id?',
        name: 'block14c',
        props: true,
        component: () => import(/* webpackChunkName: "block14" */ './block14c')
      },
    
    // {
    //   path: '/block14d/:id?',
    //   name: 'block14d',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block14" */ './block14d')
    // },
    // {
    //   path: '/block14e/:id?',
    //   name: 'block14e',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block14" */ './block14e')
    // },
    // {
    //   path: '/block14f/:id?',
    //   name: 'block14f',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block14" */ './block14f')
    // },
    {
      path: '/block14g/:id?',
      name: 'block14g',
      props: true,
      component: () => import(/* webpackChunkName: "block14" */ './block14g')
    },
    {
      path: '/block14h/:id?',
      name: 'block14h',
      props: true,
      component: () => import(/* webpackChunkName: "block14" */ './block14h')
    },
    {
      path: '/block14i/:id?',
      name: 'block14i',
      props: true,
      component: () => import(/* webpackChunkName: "block14" */ './block14i')
    },
    {
      path: '/block15/:id?',
      name: 'block15',
      props: true,
      component: () => import(/* webpackChunkName: "block15" */ './block15')
    },
    {
      path: '/block16/:id?',
      name: 'block16',
      props: true,
      component: () => import(/* webpackChunkName: "block16" */ './block16')
    },
    {
      path: '/block17/:id?',
      name: 'block17',
      props: true,
      component: () => import(/* webpackChunkName: "block17" */ './block17')
    },
    {
      path: '/block18/:id?',
      name: 'block18',
      props: true,
      component: () => import(/* webpackChunkName: "block18" */ './block18')
    },
    {
      path: '/block20/:id?',
      name: 'block20',
      props: true,
      component: () => import(/* webpackChunkName: "block20" */ './block20')
    },
    {
      path: '/block23/:id?',
      name: 'block23',
      props: true,
      component: () => import(/* webpackChunkName: "block23" */ './block23')
    },
    {
      path: '/block24/:id?',
      name: 'block24',
      props: true,
      component: () => import(/* webpackChunkName: "block24" */ './block24')
    },
    {
      path: '/block24a/:id?',
      name: 'block24a',
      props: true,
      component: () => import(/* webpackChunkName: "block25" */ './block24a')
    },
    // {
    //   path: '/block29/:id?',
    //   name: 'block29',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block29" */ './block29')
    // },
    // {
    //   path: '/block29a/:id?',
    //   name: 'block29a',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block29" */ './block29a')
    // },
    {
      path: '/block31a/:id?',
      name: 'block31a',
      props: true,
      component: () => import(/* webpackChunkName: "block30" */ './block31a')
    },
    {
      path: '/block31b/:id?',
      name: 'block31b',
      props: true,
      component: () => import(/* webpackChunkName: "block31" */ './block31b')
    },
    // {
    //   path: '/block31c/:id?',
    //   name: 'block31c',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block31" */ './block31c')
    // },
    {
      path: '/block31d/:id?',
      name: 'block31d',
      props: true,
      component: () => import(/* webpackChunkName: "block31" */ './block31d')
    },
    {
      path: '/block31e/:id?',
      name: 'block31e',
      props: true,
      component: () => import(/* webpackChunkName: "block31" */ './block31e')
    },
    {
      path: '/block32/:id?',
      name: 'block32/:id?',
      component: () => import(/* webpackChunkName: "block32" */ './block32')
    },
    {
      path: '/block33/:id?',
      name: 'block33',
      props: true,
      component: () => import(/* webpackChunkName: "block33" */ './block33')
    },
    {
      path: '/block33a/:id?',
      name: 'block33a',
      props: true,
      component: () => import(/* webpackChunkName: "block33" */ './block33a')
    },
    {
      path: '/block33b/:id?',
      name: 'block33b',
      props: true,
      component: () => import(/* webpackChunkName: "block33" */ './block33b')
    },
    // {
    //   path: '/block34a/:id?',
    //   name: 'block34a',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block34" */ './block34a')
    // },
    {
      path: '/block34b/:id?',
      name: 'block34b',
      props: true,
      component: () => import(/* webpackChunkName: "block34" */ './block34b')
    },
    {
      path: '/block35/:id?',
      name: 'block35',
      props: true,
      component: () => import(/* webpackChunkName: "block35" */ './block35')
    },
    {
      path: '/block36/:id?',
      name: 'block36',
      props: true,
      component: () => import(/* webpackChunkName: "block36" */ './block36')
    },
    {
      path: '/block37/:id?',
      name: 'block37',
      props: true,
      component: () => import(/* webpackChunkName: "block37" */ './block37')
    },
    {
      path: '/block38/:id?',
      name: 'block38',
      props: true,
      component: () => import(/* webpackChunkName: "block38" */ './block38')
    },
    {
      path: '/block39/:id?',
      name: 'block39',
      props: true,
      component: () => import(/* webpackChunkName: "block39" */ './block39')
    },
    {
      path: '/block40/:id?',
      name: 'block40',
      props: true,
      component: () => import(/* webpackChunkName: "block40" */ './block40')
    },
    {
      path: '/block41/:id?',
      name: 'block41',
      props: true,
      component: () => import(/* webpackChunkName: "block41" */ './block41')
    },
    {
      path: '/block42/:id?',
      name: 'block42',
      props: true,
      component: () => import(/* webpackChunkName: "block42" */ './block42')
    },
    // {
    //   path: '/block45a/:id?',
    //   name: 'block45a',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block45" */ './block45a')
    // },
    {
      path: '/block46/:id?',
      name: 'block46',
      props: true,
      component: () => import(/* webpackChunkName: "block46" */ './block46')
    },
    {
      path: '/search/:id?',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ './search')
    }
  ]
})
